import { Button } from '@cokitchen/cokitchen-components';
import React, { FC } from 'react';
import { ReactComponent as LogoutIcon } from 'assets/icons/error.svg';
import LocalModal from 'components/base/local-modal';
import { ConversionListType } from 'models/pricing.model';

interface ArchiveModalProps {
  show: boolean;
  onClose: () => void;
  selectedVendor: ConversionListType[];
  singleSelectedVendor: ConversionListType | null;
  onConfirm: () => void;
  loading: boolean;
}

interface ArchiveModalFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ArchiveModalFooter: FC<ArchiveModalFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='flex gap-2 items-center justify-center'>
    <button className=' bg-[#F2F2F2] w-[139px] h-[41px] rounded-[100px] ' onClick={onCancel}>
      Cancel
    </button>
    <Button
      small
      color='primary'
      variant='block'
      className='w-[139px] h-[41px]'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const ArchiveModal: FC<ArchiveModalProps> = ({
  show,
  onClose,
  singleSelectedVendor,
  selectedVendor,
  onConfirm,
  loading
}) => {
  return (
    <LocalModal
      isOpen={show}
      title=''
      description={``}
      titleIconColor='danger'
      onRequestClose={onClose}
      contentClassName='!max-w-[400px]'
      footer={<ArchiveModalFooter loading={loading} onCancel={onClose} onConfirm={onConfirm} />}>
      <div className='flex flex-col justify-center items-center'>
        <LogoutIcon />
        {selectedVendor && selectedVendor.length > 1 ? (
          <div>
            <p className='  text-[26px] py-2'>
              Are you sure you want to archive the selected items?
            </p>
          </div>
        ) : (
          <div>
            <p className='text-[16px] font-medium py-2'>
              Are you sure you want to archive {singleSelectedVendor?.ingredient.name} ?
            </p>
            <p className='text-sm text-[#6F7376] text-center'>
              This will delete data associated with this vendor
            </p>
          </div>
        )}
      </div>
    </LocalModal>
  );
};

export default ArchiveModal;
